import { render, staticRenderFns } from "./SidebarItem.vue?vue&type=template&id=4ea5f6f4&"
import script from "./SidebarItem.vue?vue&type=script&lang=ts&"
export * from "./SidebarItem.vue?vue&type=script&lang=ts&"
import style0 from "./SidebarItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports